import AppDispatcher from '../../core/AppDispatcher'
import SegmentationEvent from '../../event/SegmentationEvent'

const onEdit = event => {
  AppDispatcher.dispatchWithType(SegmentationEvent.onEdit, {
    name: event.target.name,
    value: event.target.value
  })

  return true
}

export default onEdit
